class ProductPicker {
  constructor() {
    this.offersGroups = document.querySelectorAll('.picker-dogsize_offers-group');
    this.offersItems = document.querySelectorAll('.picker-offer_input');
    this.dogSizeInputs = document.querySelectorAll('.picker-dogsize_input');
    this.purchaseTypeInput = document.getElementById('js__picker-purchase_type');
    this.dogSizesTrigger = document.getElementById('dogsizes-selector-trigger');
    this.dogsizesTarget = document.getElementById('dogsizes-selector-target');
    this.productForm = document.getElementById('product-picker-form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.skipCart = this.productForm?.dataset?.skipCart !== undefined;
    this.subscriptionNotice = document.querySelector('subscription-notice');
    this.subscriptionNotice && this.subscriptionNotice.init(this);

    this.init();
  }

  init() {
    this.dogSizeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateOfferGroups();
        if (window.innerWidth < 950) {
          this.updateDogsizeSelector(input);
        }
      });
    });

    this.offersItems.forEach((offer) => {
      offer.addEventListener('change', () => this.updateCTA());
      offer.addEventListener('change', this.croUpdateCTA.bind(this));
      offer.addEventListener('change', () => this.updateCheckoutButton());
    });

    this.purchaseTypeInput?.addEventListener('change', () => {
      this.updateOfferGroups();
    });

    document.addEventListener('DOMContentLoaded', () => {
      this.updateOfferGroups();
    });

    this.dogSizesTrigger?.addEventListener('click', () => {
      if (this.dogsizesTarget?.classList.contains('dogsizes-hidden')) {
        this.dogsizesTarget.classList.remove('dogsizes-hidden');
      } else {
        this.dogsizesTarget?.classList.add('dogsizes-hidden');
      }
    });

    const addToCartButton = document.getElementById('picker-submit_button-sub');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.subscriptionNotice ? this.subscriptionNotice.open() : this.prepareAddToCart();
      });
    }

    const otpButton = document.getElementById('picker-submit_button-otp');
    if (otpButton) {
      otpButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.addToCartOTP();
      });
    }

    const otpCheckoutButton = document.getElementById('picker-submit_button-otp-checkout');
    if (otpCheckoutButton) {
      otpCheckoutButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.addToCartOTPDirectCheckout();
      });
    }

    const checkoutButton = document.getElementById('picker-checkout_button');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.prepareDirectCheckout();
      });
    }

    this.offersGroups.forEach((group) => {
      group.addEventListener('change', (event) => {
        if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
          const selectedIndex = [...group.querySelectorAll('input[type="radio"]')].indexOf(event.target);
          this.syncOfferInputs(selectedIndex, group);
        }
      });
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.refreshCartState();
      }
    });
  }

  updateCartWithoutOpening(parsedState) {
    if (!this.cart || !parsedState.sections) {
      console.warn('updateCartWithoutOpening: Missing cart or sections', {
        cart: !!this.cart,
        sections: !!parsedState.sections,
      });
      return;
    }

    const drawerInner = this.cart.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    if (this.cart.getSectionsToRender && this.cart.getSectionInnerHTML) {
      this.cart.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (sectionElement && parsedState.sections[section.id]) {
          try {
            // Null when the selector misses — cart-icon-bubble returns a bare fragment with
            // no .shopify-section wrapper. Assigning it would render the string "null".
            const updatedHTML = this.cart.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            if (updatedHTML !== null) sectionElement.innerHTML = updatedHTML;
          } catch (e) {
            console.error('Error updating section:', section.id, e);
          }
        }
      });
    }
  }

  refreshCartState() {
    if (this.cart && this.cart.tagName === 'CART-DRAWER') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          const cartIconBubble = html.querySelector('#cart-icon-bubble');
          if (cartIconBubble) {
            const targetCartIcon = document.querySelector('#cart-icon-bubble');
            if (targetCartIcon) {
              targetCartIcon.replaceWith(cartIconBubble);
              if (this.cart.setHeaderCartIconAccessibility) {
                this.cart.setHeaderCartIconAccessibility();
              }
            }
          }
        })
        .catch((e) => {
          console.error('Error refreshing cart state:', e);
        });
    }
  }

  updateCTA() {
    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked');
        if (!activeOffer) return;

        const activeOfferPrice = activeOffer.getAttribute('data-discounted-price');
        const activeOfferDefaultPrice = activeOffer.dataset.defaultPrice;
        const activeOfferSAvePrice = activeOffer.dataset.savePrice;

        const submitPriceElement = document.getElementById('picker_submit_btn-price_discounted');
        const submitOldPriceElement = document.getElementById('picker_submit_btn-price_old');

        if (submitPriceElement) {
          submitPriceElement.textContent = activeOfferPrice;
          if (submitOldPriceElement) {
            if (activeOfferPrice !== activeOfferDefaultPrice) {
              submitOldPriceElement.textContent = activeOfferDefaultPrice;
              submitOldPriceElement.style.display = 'inline-block';
            } else {
              submitOldPriceElement.style.display = 'none';
            }
          }
        }
      }
    });
  }

  updateCheckoutButton() {
    const checkoutPriceElement = document.getElementById('picker_checkout_btn-price_discounted');
    const checkoutOldPriceElement = document.getElementById('picker_checkout_btn-price_old');
    if (!checkoutPriceElement) return;

    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked');
        if (activeOffer) {
          const activeOfferPrice = activeOffer.getAttribute('data-discounted-price');
          const activeOfferDefaultPrice = activeOffer.dataset.defaultPrice;

          checkoutPriceElement.textContent = activeOfferPrice;
          if (checkoutOldPriceElement) {
            if (activeOfferPrice !== activeOfferDefaultPrice) {
              checkoutOldPriceElement.textContent = activeOfferDefaultPrice;
              checkoutOldPriceElement.style.display = 'inline-block';
            } else {
              checkoutOldPriceElement.style.display = 'none';
            }
          }
        }
      }
    });
  }

  croUpdateCTA() {
    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked');
        if (!activeOffer) return;

        const croOTPPrice = activeOffer.getAttribute('data-otp-discounted-price');

        const otpPriceElement = document.getElementById('picker-otp_price');
        if (otpPriceElement) {
          otpPriceElement.textContent = croOTPPrice;
        }

        const otpCheckoutPriceElement = document.getElementById('picker-otp_price-checkout');
        if (otpCheckoutPriceElement) {
          otpCheckoutPriceElement.textContent = croOTPPrice;
        }
      }
    });
  }

  updateOfferGroups() {
    const purchaseType = this.purchaseTypeInput?.checked ? 'sub' : 'otp';

    this.offersGroups.forEach((group) => (group.style.display = 'none'));

    const activeInput = document.querySelector('.picker-dogsize_input:checked');
    if (activeInput) {
      const activeGroupId = activeInput.getAttribute('data-offers-group') + '-' + purchaseType;
      const activeGroup = document.getElementById(activeGroupId);
      if (activeGroup) {
        activeGroup.style.display = 'block';
      }
    }

    this.updateCTA();
    this.croUpdateCTA();
    this.updateCheckoutButton();
  }

  syncOfferInputs(selectedIndex, currentGroup) {
    this.offersGroups.forEach((otherGroup) => {
      if (otherGroup !== currentGroup) {
        const correspondingRadio = otherGroup.querySelectorAll('input[type="radio"]')[selectedIndex];
        if (correspondingRadio) {
          correspondingRadio.checked = true;
        }
      }
    });
  }

  addToCartOTP() {
    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked'),
          quantity = activeOffer.getAttribute('data-quantity'),
          variantId = activeOffer.getAttribute('data-otp-variant-id'),
          sellingPlan = 'otp',
          klaviyoTagsArr = {};

        let productType = activeOffer.getAttribute('data-product-type'),
          dogSizeTitle = activeOffer.getAttribute('data-dogsize'),
          sellingPlanTitle = activeOffer.getAttribute('data-interval-title'),
          klaviyoTagName = '',
          klaviyoTagValue = '';

        if (dogSizeTitle !== '') {
          klaviyoTagName = productType + '-' + dogSizeTitle;
        } else {
          klaviyoTagName = productType;
        }

        if (dogSizeTitle !== '') {
          klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-nosub';
        } else {
          klaviyoTagValue = quantity + '-nosub';
        }

        klaviyoTagsArr[klaviyoTagName] = klaviyoTagValue;

        const productData = {
          items: [
            {
              id: variantId,
              quantity: quantity,
              properties: {
                _klaviyo_custom_tag: klaviyoTagsArr,
                _jc_dogsize: dogSizeTitle,
                _product_type: productType,
              },
            },
          ],
          sections: this.skipCart ? null : this.cart.getSectionsToRender().map((section) => section.id),
        };

        this.addToCart(productData, klaviyoTagsArr);
      }
    });
  }

  addToCartOTPDirectCheckout() {
    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked'),
          quantity = activeOffer.getAttribute('data-quantity'),
          variantId = activeOffer.getAttribute('data-otp-variant-id'),
          sellingPlan = 'otp',
          klaviyoTagsArr = {};

        let productType = activeOffer.getAttribute('data-product-type'),
          dogSizeTitle = activeOffer.getAttribute('data-dogsize'),
          sellingPlanTitle = activeOffer.getAttribute('data-interval-title'),
          klaviyoTagName = '',
          klaviyoTagValue = '';

        if (dogSizeTitle !== '') {
          klaviyoTagName = productType + '-' + dogSizeTitle;
        } else {
          klaviyoTagName = productType;
        }

        if (dogSizeTitle !== '') {
          klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-nosub';
        } else {
          klaviyoTagValue = quantity + '-nosub';
        }

        klaviyoTagsArr[klaviyoTagName] = klaviyoTagValue;
        const _source_type = document.body.dataset.sourceType;
        const _source_id = document.body.dataset.sourceId;
        const _source_handle = document.body.dataset.sourceHandle;

        const sectionsToRender = [];
        if (this.cart && this.cart.getSectionsToRender) {
          sectionsToRender.push(...this.cart.getSectionsToRender().map((section) => section.id));
        }

        const productData = {
          items: [
            {
              id: variantId,
              quantity: quantity,
              properties: {
                _klaviyo_custom_tag: klaviyoTagsArr,
                _jc_dogsize: dogSizeTitle,
                _product_type: productType,
                _source_type,
                _source_id,
                _source_handle,
              },
            },
          ],
        };

        if (sectionsToRender.length > 0) {
          productData.sections = sectionsToRender;
        }

        const originalSkipCart = this.skipCart;
        this.skipCart = true;

        const addToCartPromise = this.addToCart(productData, {
          ...klaviyoTagsArr,
          _source_handle,
          _source_id,
          _source_type,
        });

        addToCartPromise
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.skipCart = originalSkipCart;
          });
      }
    });
  }

  prepareAddToCart() {
    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked'),
          quantity = activeOffer.getAttribute('data-quantity'),
          variantId = activeOffer.getAttribute('data-variant-id'),
          sellingPlan = activeOffer.getAttribute('data-selling-plan'),
          klaviyoTagsArr = {};

        let productType = activeOffer.getAttribute('data-product-type'),
          dogSizeTitle = activeOffer.getAttribute('data-dogsize'),
          sellingPlanTitle = activeOffer.getAttribute('data-interval-title'),
          klaviyoTagName = '',
          klaviyoTagValue = '';

        if (dogSizeTitle !== '') {
          klaviyoTagName = productType + '-' + dogSizeTitle;
        } else {
          klaviyoTagName = productType;
        }

        if (sellingPlan !== 'otp') {
          klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-sub';
        } else {
          if (dogSizeTitle !== '') {
            klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-nosub';
          } else {
            klaviyoTagValue = quantity + '-nosub';
          }
        }

        klaviyoTagsArr[klaviyoTagName] = klaviyoTagValue;
        const _source_type = document.body.dataset.sourceType;
        const _source_id = document.body.dataset.sourceId;
        const _source_handle = document.body.dataset.sourceHandle;

        const productData = {
          items: [
            {
              id: variantId,
              quantity: quantity,
              properties: {
                _klaviyo_custom_tag: klaviyoTagsArr,
                _jc_dogsize: dogSizeTitle,
                _product_type: productType,
                _source_type,
                _source_id,
                _source_handle,
              },
            },
          ],
          sections: this.skipCart ? null : this.cart.getSectionsToRender().map((section) => section.id),
        };

        sellingPlan !== 'otp' && (productData.items[0].selling_plan = sellingPlan);

        const originalSkipCart = this.skipCart;
        this.skipCart = false;

        this.addToCart(productData, { ...klaviyoTagsArr, _source_handle, _source_id, _source_type })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.skipCart = originalSkipCart;
          });
      }
    });
  }

  addToCart(productData, orderAttributesArr = {}) {
    let sectionsToRender = [];
    if (this.cart && this.cart.getSectionsToRender) {
      sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
    }

    if (productData.sections && Array.isArray(productData.sections) && productData.sections.length > 0) {
      sectionsToRender = productData.sections;
    }

    const { sections: _, ...productDataWithoutSections } = productData;
    const requestBody = { ...productDataWithoutSections, attributes: orderAttributesArr };

    if (sectionsToRender.length > 0) {
      requestBody.sections = sectionsToRender;
    }

    return fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }
        return response.json();
      })
      .then((response) => {
        if (response.status || response.description || response.errors) {
          console.error('Cart add error:', response);
          throw new Error(response.description || response.message || 'Error adding product to cart');
        }

        if (!response.items || response.items.length === 0) {
          console.error('Cart add failed: No items in response');
          throw new Error('Failed to add item to cart');
        }

        if (!this.skipCart) {
          if (response.sections && this.cart && this.cart.renderContents) {
            this.cart.renderContents(response);
          }
        } else {
          if (response.sections && this.cart) {
            this.updateCartWithoutOpening(response);
          } else if (this.cart) {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const cartIconBubble = html.querySelector('#cart-icon-bubble');
                if (cartIconBubble) {
                  const targetCartIcon = document.querySelector('#cart-icon-bubble');
                  if (targetCartIcon) {
                    targetCartIcon.replaceWith(cartIconBubble);
                    if (this.cart.setHeaderCartIconAccessibility) {
                      this.cart.setHeaderCartIconAccessibility();
                    }
                  }
                }
              })
              .catch((e) => {
                console.error('Error updating cart counter:', e);
              });
          }
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 400);
        }
        return response;
      })
      .catch((e) => {
        console.error(e);
        alert(e.message || 'Error adding product to cart. Please try again.');
        throw e;
      })
      .finally(() => {
        if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }

  prepareDirectCheckout() {
    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked'),
          quantity = activeOffer.getAttribute('data-quantity'),
          variantId = activeOffer.getAttribute('data-variant-id'),
          sellingPlan = activeOffer.getAttribute('data-selling-plan'),
          klaviyoTagsArr = {};

        let productType = activeOffer.getAttribute('data-product-type'),
          dogSizeTitle = activeOffer.getAttribute('data-dogsize'),
          sellingPlanTitle = activeOffer.getAttribute('data-interval-title'),
          klaviyoTagName = '',
          klaviyoTagValue = '';

        if (dogSizeTitle !== '') {
          klaviyoTagName = productType + '-' + dogSizeTitle;
        } else {
          klaviyoTagName = productType;
        }

        if (sellingPlan !== 'otp') {
          klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-sub';
        } else {
          if (dogSizeTitle !== '') {
            klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-nosub';
          } else {
            klaviyoTagValue = quantity + '-nosub';
          }
        }

        klaviyoTagsArr[klaviyoTagName] = klaviyoTagValue;
        const _source_type = document.body.dataset.sourceType;
        const _source_id = document.body.dataset.sourceId;
        const _source_handle = document.body.dataset.sourceHandle;

        const sectionsToRender = [];
        if (this.cart && this.cart.getSectionsToRender) {
          sectionsToRender.push(...this.cart.getSectionsToRender().map((section) => section.id));
        }

        const productData = {
          items: [
            {
              id: variantId,
              quantity: quantity,
              properties: {
                _klaviyo_custom_tag: klaviyoTagsArr,
                _jc_dogsize: dogSizeTitle,
                _product_type: productType,
                _source_type,
                _source_id,
                _source_handle,
              },
            },
          ],
        };

        if (sectionsToRender.length > 0) {
          productData.sections = sectionsToRender;
        }

        sellingPlan !== 'otp' && (productData.items[0].selling_plan = sellingPlan);

        const originalSkipCart = this.skipCart;
        this.skipCart = true;

        const addToCartPromise = this.addToCart(productData, {
          ...klaviyoTagsArr,
          _source_handle,
          _source_id,
          _source_type,
        });

        addToCartPromise
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.skipCart = originalSkipCart;
          });
      }
    });
  }

  updateDogsizeSelector(dogsize) {
    const dogsizeText = dogsize.getAttribute('data-dogsize-title');
    this.dogSizesTrigger.textContent = dogsizeText;
    this.dogsizesTarget.classList.add('dogsizes-hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const newPicker = new ProductPicker();
  newPicker.updateOfferGroups();
  newPicker.updateCTA();
  newPicker.croUpdateCTA();
  newPicker.updateCheckoutButton();
});

class DeliveryTimer {
  constructor() {
    if (document.querySelector('.delivery-timer')) {
      this.initTimer();
    }
  }

  initTimer() {
    this.updateDeliveryTimer();
    setInterval(() => this.updateDeliveryTimer(), 1000);
  }

  updateDeliveryTimer() {
    const now = new Date();
    const targetTime = new Date(now);
    targetTime.setUTCHours(12, 0, 0, 0);

    const wrapper = document.querySelector('.delivery-timer');

    if (now.getUTCHours() >= 12) {
      targetTime.setUTCDate(targetTime.getUTCDate() + 1);
      wrapper.classList.remove('before_noon');
      wrapper.classList.add('after_noon');
    } else {
      wrapper.classList.remove('after_noon');
      wrapper.classList.add('before_noon');
    }

    const diff = targetTime.getTime() - now.getTime();

    const hours = this.formatTimeUnit(Math.floor(diff / (1000 * 60 * 60)));
    const minutes = this.formatTimeUnit(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = this.formatTimeUnit(Math.floor((diff % (1000 * 60)) / 1000));

    document.querySelector('.timer').innerHTML = `${hours} : ${minutes} : ${seconds}`;
  }

  formatTimeUnit(unit) {
    return unit < 10 ? '0' + unit : unit;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DeliveryTimer();
});

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('js__picker-purchase_type');
  const wrapper = document.querySelector('.picker-purchase_type-wrapper');

  if (!checkbox || !wrapper) return;

  function toggleActiveClass() {
    if (checkbox.checked) {
      wrapper.classList.add('active');
    } else {
      wrapper.classList.remove('active');
    }
  }

  toggleActiveClass();

  checkbox.addEventListener('change', toggleActiveClass);
});

class SubscriptionNotice extends HTMLElement {
  constructor() {
    super();

    this.continueButton = this.querySelector('button');
    this.accountButton = this.querySelector('a');
    this.header = document.querySelector('header').parentElement;
    this.currentProductSku = this.dataset.sku;
    this.userCurrentSubscriptions = localStorage.getItem('user-current-subs') || [];
    this.accountLink = this.header.querySelector('.js__recharge_login_link')?.href;
    this.picker = false;
  }

  init(picker) {
    this.picker = picker;
    this.purchaseTypeInput = this.picker.purchaseTypeInput;
    this.picker ? this.continueButton.addEventListener('click', this.close.bind(this)) : null;
    this.accountLink = this.header.querySelector('.js__recharge_login_link')?.href;

    if (this.accountLink) this.accountButton.href = this.accountLink;
  }

  open() {
    let isSubscription = this.picker.purchaseTypeInput?.checked;
    if (typeof window.wuffesDosageRecForceSubscription === 'boolean') {
      isSubscription = window.wuffesDosageRecForceSubscription;
    } else if (typeof window.wuffesFeedingRecForceSubscription === 'boolean') {
      isSubscription = window.wuffesFeedingRecForceSubscription;
    }

    if (this.picker) {
      if (isSubscription && this.userCurrentSubscriptions.includes(this.currentProductSku)) {
        this.setAttribute('shown', '');
        this.header.classList.add('hidden');
        document.body.classList.add('overflow-hidden');
      } else if (typeof window.wuffesDosageRecPrepareAddToCart === 'function') {
        const fn = window.wuffesDosageRecPrepareAddToCart;
        window.wuffesDosageRecPrepareAddToCart = null;
        window.wuffesDosageRecForceSubscription = null;
        fn();
      } else if (typeof window.wuffesFeedingRecPrepareAddToCart === 'function') {
        const fn = window.wuffesFeedingRecPrepareAddToCart;
        window.wuffesFeedingRecPrepareAddToCart = null;
        window.wuffesFeedingRecForceSubscription = null;
        fn();
      } else {
        this.picker.prepareAddToCart();
      }
    }
  }

  close(event) {
    event.preventDefault();

    this.removeAttribute('shown');
    this.header.classList.remove('hidden');
    document.body.classList.remove('overflow-hidden');

    if (typeof window.wuffesDosageRecAfterSubNotice === 'function') {
      const fn = window.wuffesDosageRecAfterSubNotice;
      window.wuffesDosageRecAfterSubNotice = null;
      window.wuffesDosageRecForceSubscription = null;
      fn();
    } else if (typeof window.wuffesFeedingRecAfterSubNotice === 'function') {
      const fn = window.wuffesFeedingRecAfterSubNotice;
      window.wuffesFeedingRecAfterSubNotice = null;
      window.wuffesFeedingRecForceSubscription = null;
      fn();
    } else if (this.picker) {
      this.picker.prepareAddToCart();
    }
  }
}
customElements.define('subscription-notice', SubscriptionNotice);
